<template>
  <I18NRouteLink :to="props.disabled ? `` : `/${props.ruta}`">
    <li class="nav-item">
      <a :class="['nav-link flex-lg-column flex-xl-row', { active: props.esActivo }]" aria-current="page">
        <i v-if="props.iconCss" :class="['me-lg-1 me-2', props.iconCss]"></i>
        {{ props.texto }}</a
      >
    </li>
  </I18NRouteLink>
</template>

<script setup lang="ts">
import I18NRouteLink from "@/.shared/components/i18n/I18NRouteLink.vue";

const props = defineProps({
  ruta: String,
  esActivo: Boolean,
  texto: String,
  disabled: Boolean,
  iconCss: String,
});
</script>

<style scoped lang="scss">
.nav-item a:not(.active) {
  color: var(--button-ui-nav-nav-item-default);
}

.navbar-nav .nav-link.active {
  border-bottom: var(--border-width-lg) solid var(--border-secondary-default);
  padding-bottom: var(--spacing-2xs);
}

.nav-item i {
  font-size: var(--font-size-body-lg);
  color: var(--icon-secondary-default);
}

@media (max-width: 991px) {
  .navbar-collapse.collapse .nav-link {
    padding: var(--spacing-md) var(--spacing-0);
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav .nav-link,
  .navbar-text {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    gap: var(--spacing-2xs);
    align-items: center;
    min-height: 70px;
  }
}

@media (max-width: 1600px) {
  .nav-item span {
    display: none !important;
  }
}
</style>
